import { useEffect, useState } from "react";
import styles from "./previewtemplate.module.css";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import { Typography } from "@mui/material";
import { ArrowLeft, Home } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../../../components/Loader";
import Footer from "../../../../../components/Footer";
import axios from "axios";
import { TableLoader } from "../../../../../components/LoaderC";
import withCustomAuthenticationRequired from "../../../../../auth/withCustomAuthenticationRequired";

const PreviewTemplate = ({ history, match }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { id } = match.params;
    const [contentLoading, setContentLoading] = useState(true);
    const [templateData, setTemplateData] = useState(null);

    useEffect(() => {
        const fetchDetails = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/template/details/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setTemplateData(response.data.data);
            }).catch((error) => { });
        }

        if (id) {
            fetchDetails();
        }
    }, [id]);

    return (<>
        <Helmet title="Preview Email Template" />

        <div className={`${styles.mainCard}`}>
            <div className={`${styles.SMProCusRow}`}>
                <div className={`${styles.BreadcrumbHeadSec}`}>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Tenant Renewal</li>
                            <li className={`${styles.breadcrumbItem}`}>
                                <Link to={"/communication/renewal-offers"}>Renewal Offers</Link>
                            </li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>Preview Offer</li>
                        </ol>
                    </nav>
                    <div className={`${styles.PageTitleSec}`}>
                        <div>
                            <Link to={`/communication/renewal-offers`} className={`${styles.BackArrow}`}>
                                <ArrowLeft />
                            </Link>
                            <Typography display="inline" className={`${styles.pageTitle}`}>Preview Offer</Typography>
                        </div>
                    </div>
                </div>

                <div className={`${styles.mainCardUnder}`}>

                    {contentLoading && (<div className="Loader TableLoader">
                        <TableLoader />
                    </div>)}

                    {!contentLoading && <div dangerouslySetInnerHTML={{ __html: templateData?.desc_html }} />}

                </div>

            </div>
        </div >

        <Footer />
    </>
    )
}

export default withCustomAuthenticationRequired(PreviewTemplate, {
    onRedirecting: () => <Loader />,
});